/*
 * Inputs: Count as Number - Max as number
 * Return `More than {max}` if Count is greater than max
 */
export function useFormatMoreThan() {
  const { $i18n: { t } } = useNuxtApp()

  return ({ count, max = 100 }: { count: number, max?: number }) => {
    return count > max ? t('commons.estimate.more_than_dynamic', { x_string: max }) : count
  }
}
